import React from 'react';
import './Announcement.scss';

function Announcement({announcement}) {
    return (
        <span className="announcement-text">{announcement.message}</span>
    )
}

export default Announcement;